import React, { FC } from "react";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Select,
  InputNumber,
  Card,
  Row,
  Col,
  Typography,
  Spin,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import DischargeDocumentUpload from "../IHX/IHXTabs/DischargeDocumentUpload";
import ResponseDischargeDocumentUpload from "../IHX/IHXTabs/ResponseDischargeDocumentUpload";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { BILL_AUDIT, ROUTES } from "../../../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

const { Title } = Typography;

interface DischargeStarHealthProps {
  form: any;
  isLoading: boolean;
  roomTypes: any[];
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  isEditable?: boolean;
  isApproved?: boolean;
  handleSaveData?: () => void;
  preAuth?: any;
  activeKey?: string;
  isSubmitting?: boolean;
  isIntimating?: boolean;
  isSaving?: boolean;
  handleSaveConfirmationModal: (state: string) => void;
  caseDischargeData?: any;
  loading?: boolean;
  isApprovedInitiated: boolean;
  uploadFileList: any;
}

const DischargeStarHealth: FC<DischargeStarHealthProps> = ({
  form,
  isLoading,
  roomTypes,
  documentTypes = [],
  documentUrls = [],
  documentRequestResponseDocuments = {},
  handleFileChange,
  handleOpen,
  isEditable = true,
  isApproved = false,
  handleSaveData,
  preAuth,
  activeKey,
  isSubmitting,
  isIntimating,
  isSaving,
  handleSaveConfirmationModal,
  caseDischargeData,
  loading,
  isApprovedInitiated,
  uploadFileList
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth, patients } = useSelector((state: RootState) => state);
  const navigate = useNavigate();

  return (
    <div>
      <Title level={5}>BASIC DETAILS</Title>
      <Form
        form={form}
        layout="vertical"
        // onFinish={onFinish}
      >
        {/* <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="nameForPatient"
              label="NAME"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="genderForPatient" label="GENDER">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row> */}

        {/* <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="procedure"
              label="PROCEDURE"
              rules={[{ required: true, message: "Please enter procedure" }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row> */}

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="dateOfAdmission"
              label="DATE & TIME OF ADMISSION"
              rules={[
                {
                  required: true,
                  message: "Please select admission date & time",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY HH:mm:ss"
                showTime
                disabled={!isEditable}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="dateOfDischarge"
              label="DATE & TIME OF DISCHARGE"
              rules={[
                {
                  required: true,
                  message: "Please select discharge date & time",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY HH:mm:ss"
                showTime
                disabled={!isEditable}
                // disabledDate={(current) => {
                //   const admissionDate = form.getFieldValue("dateOfAdmission");
                //   return (
                //     current &&
                //     (current < dayjs(admissionDate) ||
                //       current > dayjs().endOf("day"))
                //   );
                // }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="totalAmount"
              label="REQUESTED AMOUNT"
              rules={[
                { required: true, message: "Please enter requested amount" },
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                style={{ width: "100%" }}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={["roomType", "id"]}
              label="ROOM TYPE"
              rules={[{ required: true, message: "Please select room type" }]}
            >
              <Select
                placeholder="SELECT ROOM TYPE"
                disabled={!isEditable}
                onChange={(value) => {
                  const selectedRoom = roomTypes.find(
                    (room) => room.id === value
                  );
                  form.setFieldsValue({
                    roomType: {
                      id: value,
                      name: selectedRoom?.roomType || "",
                    },
                  });
                }}
              >
                {roomTypes?.map((room) => (
                  <Select.Option key={room.id} value={room.id}>
                    {room.roomType}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Title level={5}>ADD TREATING DOCTOR DETAILS</Title>
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="treatingDoctorName"
              label="NAME OF TREATING DOCTOR"
              rules={[{ required: true, message: "Please enter doctor name" }]}
            >
              <Input
                placeholder="ENTER YOUR RESPONSE HERE..."
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="treatingDoctorQualification"
              label="QUALIFICATION OF TREATING DOCTOR"
              rules={[
                {
                  required: true,
                  message: "Please enter doctor qualification",
                },
              ]}
            >
              <Input
                placeholder="ENTER YOUR RESPONSE HERE..."
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        documentRequestResponseDocuments?.["requestedDocuments"]?.length >
          0 && (
          <DischargeDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            portalSubmission={caseDischargeData?.submitted}
            isApproved={isApproved}
            uploadFileList={uploadFileList}
            isIntimated={caseDischargeData?.intimated}
          />
        )
      )}

      {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 && (
        <ResponseDischargeDocumentUpload
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          portalSubmission={caseDischargeData?.submitted}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveData={handleSaveData}
          currentStage={preAuth?.stepperData?.currentVisitStage}
          activeKey={activeKey}
          uploadFileList={uploadFileList}
        />
      )}

      <div className="buttons" style={{ margin: "16px 0" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.8rem",
          }}
        >
          {caseDischargeData?.submitted ||
          caseDischargeData?.initiated
          // || caseDischargeData?.approved 
          ? (
            <></>
          ) : !caseDischargeData?.id ? (
            <div style={{ width: "16%" }}>
              <Button
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 76, 143)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                onClick={() => handleSaveConfirmationModal("save")}
                loading={isSaving}
              >
                SAVE
              </Button>
            </div>
          ) : (
            // !(
            //   auth?.role?.role == "FO_STAFF" && caseDischargeData?.intimated
            // ) && 
            (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  onClick={() => handleSaveConfirmationModal("update")}
                  loading={isSaving}
                >
                  UPDATE
                </Button>
              </div>
            )
          )}

          {hasFunctionality("dischargeIntimation") &&
            !(
              caseDischargeData?.intimated ||
              caseDischargeData?.submitted ||
              caseDischargeData?.initiated ||
              caseDischargeData?.approved
            ) && (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  onClick={() => handleSaveConfirmationModal("intimate")}
                  loading={isIntimating}
                >
                  Send To QC
                </Button>
              </div>
            )}

          {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "OP" &&
            (hasFunctionality("opdBillList") || hasFunctionality("ipdBillList")) && (
              <Link
              to={`${BILL_AUDIT}/audit/${patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId}`}
              target="_blank"
              style={{ width: "16%" }}
            >
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    // width: "100%",
                    // opacity: !isApproved ? 1 : 0.5,
                    // pointerEvents: !isApproved ? "auto" : "none",
                  }}
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                  //     navigate({
                  //       pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                  //     });
                  //   }
                  // }}
                >
                  Bill Audit
                </Button>
              </div>
              </Link>
            )}
          {/* {(patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "IP" ||
            patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "EMERGENCY") &&
            hasFunctionality("ipdBillList") && (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                    // opacity: !isApproved ? 1 : 0.5,
                    // pointerEvents: !isApproved ? "auto" : "none",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                      navigate({
                        pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                      });
                    }
                  }}
                >
                  Bill Audit
                </Button>
              </div>
            )} */}

          {hasFunctionality("dischargeApprover") &&
            !caseDischargeData?.initiated &&
            !caseDischargeData?.approved &&
            !caseDischargeData?.submitted && (
              <div style={{ width: "16%" }}>
                <Button
                  loading={isApprovedInitiated}
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                    opacity: !isApproved ? 1 : 0.5,
                    pointerEvents: !isApproved ? "auto" : "none",
                  }}
                  // onClick={handleApprove}
                  onClick={() => handleSaveConfirmationModal("approve")}
                  disabled={isApproved}
                >
                  QC Approve
                </Button>
              </div>
            )}

          {hasFunctionality("dischargeSubmission") &&
            !(
              caseDischargeData?.submitted ||
              caseDischargeData?.initiated
            ) && (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  onClick={() => handleSaveConfirmationModal("submit")}
                  loading={isSubmitting}
                >
                  {patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal ? "Initiate" : "Submit Manually"}
                </Button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DischargeStarHealth);
